import { defineStore, getActivePinia } from "pinia";
import { ref, nextTick } from "vue";
import tools from "@/utils/tools.js";
import globalConfig from "@/config/config.js";
import feedListApi from "@/api/api/feedListApi.js";
import apiReferMusic from "@/api/api/apiReferMusic.js";
import message from "@/components/functionCallComponent/message.jsx";
import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js";

import useDraftDataStore from "./draftDataStore.js";
import useLyricDataStore from "./lyricDataStore.js";
import useMuseDataStore from "./museDataStore.js";
import userReferMusicStore from "./referMusicStore.js";
// import useDraftDataStore from './draftDataStore.js';
// const draftDataStore = useDraftDataStore();
// const lyricDataStore = useLyricDataStore();
// const museDataStore = useMuseDataStore();


const MotifDataStoreApiMap = {
  1: apiReferMusic.getAllMotifMusics,
  2: apiReferMusic.getUsedMotifMusics,
  3: apiReferMusic.getMineMotifMusics,
}

const useMotifDataStore = defineStore({
  id: "motifDataStore",
  state: () => {
    return {
      TabDataSuffixMap: {
        1: "all",
        2: "used",
        3: "upload",
      },

      datas_all: [],
      datas_used: [],
      datas_upload: [],
      loadmoreid_all: "",
      loadmoreid_use: "",
      loadmoreid_upload: "",
      isloading_all: false,
      hasInit_all: false,
      isloading_use: false,
      hasInit_use: false,
      isloading_upload: false,
      hasInit_upload: false,

      loadtimestamp_all: "",
      loadtimestamp_use: "",
      loadtimestamp_upload: "",
      filterAllData: {},

      curUseReferMusic: null,
      curUseMusicTabCode: null,
      motifData: null,
    };
  },
  actions: {
    initLibraryData() {
      this.datas_all = [];
      this.loadmoreid_all = "";
    },
    initMotifData(data) {
      this.updateMotifData(data?.motif ?? null);
    },
    clearAllMotifSelectData() {
      this.datas_all = [];
      this.loadmoreid_all = "";
      this.datas_used = [];
      this.loadmoreid_use = "";
      this.loadtimestamp_use = "";
      this.datas_upload = [];
      this.loadmoreid_upload = "";
      this.hasInit_all = false;
      this.hasInit_use = false;
      this.hasInit_upload = false;
    },
    updateMotifData(data, tabCode) {
      this.motifData = data;
      this.curUseReferMusic = data;
      useMuseDataStore().setMotifData(data);
      this.curUseMusicTabCode = tabCode;
    },
    getMotifData() {
      return this.motifData;
    },
    setMotifData(data) {
      this.motifData = data;
      this.curUseReferMusic = data;
      useMuseDataStore().setMotifData(data);
    },
    updateReferMusicTitle(id, title) {
      for (let i = 0; i < this.datas_all.length; i++) {
        if (this.datas_all[i].id == id) {
          this.datas_all[i].title = title;
          break;
        }
      }
      for (let i = 0; i < this.datas_used.length; i++) {
        if (this.datas_used[i].id == id) {
          this.datas_used[i].title = title;
          break;
        }
      }
      for (let i = 0; i < this.datas_upload.length; i++) {
        if (this.datas_upload[i].id == id) {
          this.datas_upload[i].title = title;
          break;
        }
      }
      if (this.curUseReferMusic?.id == id) {
        this.curUseReferMusic.title = title
      }
    },
    setCurUseMusic(data) {
      this.motifData = data;
      this.curUseReferMusic = data;
      useMuseDataStore().setMotifData(data);
    },
    setFilterAllData(data) {
      this.filterAllData = data;
    },
    init(params, done, errordone, isSearch, showLoading) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      const { query_type } = params;
      console.log("initreferdata", params);
      let closeMsg = null;
      return new Promise((resolve, reject) => {
        if (showLoading) {
          closeMsg = message.loading({
            position: "center",
            content: $$t("create.loading"),
          });
        }

        this[`isloading_${this.TabDataSuffixMap[query_type]}`] = true;
        this.getdatas(params, done, errordone, isSearch ?? true)
          .then((datas) => {
            this[`hasInit_${this.TabDataSuffixMap[query_type]}`] = true;
            this[`isloading_${this.TabDataSuffixMap[query_type]}`] = false;
            this[`hasInit${this.TabDataSuffixMap[query_type]}`] = false;
            resolve(datas);
            closeMsg && closeMsg.clear();
          })
          .catch((err) => {
            closeMsg && closeMsg.clear();
            this[`isloading_${this.TabDataSuffixMap[query_type]}`] = false;
            reject(err);
          });
      });
    },
    getdatas(params, done, errordone, isSearch) {
      const { query_type } = params;
      let loadtimestamp = new Date().getTime();
      this[`loadtimestamp_${this.TabDataSuffixMap[query_type]}`] = loadtimestamp;
      const getReferMusics = MotifDataStoreApiMap[query_type];

      return new Promise(async (resolve, reject) => {
        getReferMusics(params)
          .then((res) => {
            const { data, code, msg } = res;
            if (code == 200) {
              if (
                !isSearch ||
                this[`loadtimestamp_${this.TabDataSuffixMap[query_type]}`] ==
                loadtimestamp
              ) {
                this[`datas_${this.TabDataSuffixMap[query_type]}`] = data.list ?? [];
                this[`loadmoreid_${this.TabDataSuffixMap[query_type]}`] =
                  data.last_id;
              }
              done && done(data.list ?? [], !data.more);
              resolve(this[`datas_${this.TabDataSuffixMap[query_type]}`]);
            } else {
              errordone && errordone(code == -200);
              // if (code == -200) {
              //   message.error({position: "top", content: msg });
              // } else {
              //   message.error({position: "top", content: "加载失败" });
              // }
              reject(this[`datas_${this.TabDataSuffixMap[query_type]}`]);
            }
          })
          .catch((err) => {
            errordone && errordone();
            reject(err);
            //   message.error({position: "top", content: "加载失败" });
          });
      });
    },
    async refresh(params, done, errordone) {
      const { query_type } = params;
      if (this[`isloading_${this.TabDataSuffixMap[query_type]}`]) {
        done && done();
        return;
      }
      this[`isloading_${this.TabDataSuffixMap[query_type]}`] = true;
      this.getdatas(params, done, errordone)
        .then((res) => {
          this[`isloading_${this.TabDataSuffixMap[query_type]}`] = false;
        })
        .catch((e) => {
          this[`isloading_${this.TabDataSuffixMap[query_type]}`] = false;
        });
    },
    async loadMore(params, done, errordone) {
      const { query_type } = params;
      params.last_id = this[`loadmoreid_${this.TabDataSuffixMap[query_type]}`];
      if (this[`isloading_${this.TabDataSuffixMap[query_type]}`]) {
        done && done();
        return;
      }
      if (!params.last_id) {
        done && done([], true);
        return;
      }
      this[`isloading_${this.TabDataSuffixMap[query_type]}`] = true;
      const getReferMusics = MotifDataStoreApiMap[query_type];

      getReferMusics(params)
        .then((res) => {
          const { data, code, msg } = res;
          if (code == 200) {
            this[`datas_${this.TabDataSuffixMap[query_type]}`] = this[
              `datas_${this.TabDataSuffixMap[query_type]}`
            ].concat(data.list ?? []);
            this[`loadmoreid_${this.TabDataSuffixMap[query_type]}`] = data.last_id;
          }
          //  else {
          //   message.error({ content: msg });
          // }

          nextTick(() => {
            if (code == 200) {
              done && done(data.list ?? [], !data.more);
            } else {
              errordone && errordone(code == -200);
            }
            this[`isloading_${this.TabDataSuffixMap[query_type]}`] = false;
          });
        })
        .catch((err) => {
          errordone && errordone(err);
        });
    },
    insertUploadData(refer) {
      this[`datas_${this.TabDataSuffixMap[3]}`] = [
        refer,
        ...this[`datas_${this.TabDataSuffixMap[3]}`],
      ];
    },
    deleteMotifDataByAudit(refer) {
      if (refer != null && refer.id == this.motifData.id) {
        this.updateMotifData(null);
      }
    },
    deleteReferItemFromList(refer, isDeleteUse) {
      let index_used = this.datas_used.findIndex((item) => item.id == refer.id);
      let index_all = this.datas_all.findIndex((item) => item.id == refer.id);

      let index_upload = this.datas_upload.findIndex(
        (item) => item.id == refer.id
      );
      if (index_used >= 0 && isDeleteUse) {
        this.datas_used.splice(index_used, 1);
        this.datas_used = [].concat(this.datas_used);
      }
      if (index_all >= 0) {
        this.datas_all.splice(index_all, 1);
        this.datas_all = [].concat(this.datas_all);
      }
      if (index_upload >= 0) {
        this.datas_upload.splice(index_upload, 1);
        this.datas_upload = [].concat(this.datas_upload);
      }
    },
    deleteReferItem(refer, query_type) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      let closeMsg = message.loading({
        position: "center",
        content: $$t("create.deleting"),
      });
      apiReferMusic
        .deleteMotifMusicItem({ id: refer.id })
        .then((res) => {
          closeMsg.clear();
          if (res.code == 200) {
            if (this.curUseReferMusic?.id == refer.id) {
              this.updateMotifData(null, null);
            }
            this.deleteReferItemFromList(refer, true);
            message.success({
              position: "top",
              content: $$t("create.delete_success"),
            });
          } else {
            message.error({
              position: "top",
              content: $$t("create.delete_failed"),
            });
          }
        })
        .catch((err) => {
          message.error({
            position: "top",
            content: $$t("create.delete_failed"),
          });
          closeMsg.clear();
        });
    },
    deleteMotifData(refer) {
      // let lastUseMusic = this.motifData;
      this.updateMotifData(null);
      // const draftDataStore = useDraftDataStore();
      // if (refer == null && lastUseMusic != null && lastUseMusic.id) {
      //   // const closeMsg=  message.loading({content: '取消中'})
      //   apiReferMusic
      //     .deleteReferenceMusic({
      //       feed_id: draftDataStore.feed_id,
      //       control_type: 2,
      //       refer_id: lastUseMusic.id,
      //     })
      //     .then((res) => {
      //       if (res.code == 200) {
      //       } else {
      //       }
      //     })
      //     .catch((err) => {
      //       //  closeMsg.clear();
      //     });
      // } else {
      // }
    },
  },
});
export default useMotifDataStore;
// export const motifDataStore = useMotifDataStore()
